











































import { computed, defineComponent, ref, reactive, toRefs } from '@vue/composition-api';
import set from 'lodash/set';
import { range, toLocaleString } from '@/common/util';
import { appName } from '@/common/const';
import lockIcon from './images/lock.png';
import coinIcon from './images/coin.png';
import coinIconSnack from './images/coin-snack.png';
import coinIconMe from './images/coin-me.png';

interface PropsType {
    pointList: number[];
    positionList: number[];
    currentGold: number;
    moreText: string;
    source: string;
}

const coins = {
    pro: coinIcon,
    me: coinIconMe,
    snack: coinIconSnack,
};

export default defineComponent<PropsType>({
    props: {
        pointList: {
            type: Array,
            default: () => [],
        },
        positionList: {
            type: Array,
            default: () => [],
        },
        currentGold: {
            type: Number,
            default: 0,
        },
        moreText: {
            type: String,
            default: '',
        },
        source: {
            type: String,
            default: '',
        },
        isReachMax: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, ctx) {
        const state = reactive({
            isRtl: ctx.root.$isRtl,
        });

        const contentElement = ref(null);
        const barElement = ref(null);

        // 将下一个阈值滚动到中间
        const scrollToMiddle = (points: Array<{value: number, gap: number}>, contentWidth: number, maxWidth: number) => {
            setTimeout(() => {
                let nextPointGap = 0;
                points.forEach((point, index) => {
                    if (nextPointGap > 0) {return;}
                    if (point.value as number >= props.currentGold) {
                        nextPointGap = point.gap;
                    } else if (index + 1 === points.length) {
                        nextPointGap = maxWidth;
                    }
                });
                const scrollGap = nextPointGap < contentWidth / 2 ? 0 : (nextPointGap - contentWidth / 2 + 12);
                set(contentElement, 'value.scrollLeft', state.isRtl ? -scrollGap : scrollGap);
            }, 60);
        };

        const getLerpInFakeNumber = (currentGold: number) => {
            const { pointList, positionList } = props;
            // 找到目标区间
            let targetRange = [];
            // 找到定位数组的区间
            let posRange = [];
            let index = 0;

            if (currentGold === 0) {
                targetRange = pointList.slice(0, 2);
            } else if (currentGold > pointList[pointList.length - 1]) {
                targetRange = pointList.slice(pointList.length - 2);
                index = pointList.length - 2;
            } else {
                let targetIndex = 0;
                for (let i = 0; i < pointList.length; i++) {
                    if (currentGold <= pointList[i]) {
                        targetIndex = i;
                        break;
                    }
                }

                targetRange = pointList.slice(targetIndex - 1, targetIndex + 1);
                index = targetIndex - 1;
            }

            posRange = positionList.slice(index, index + 2);

            return range(targetRange[0], targetRange[1], posRange[0], posRange[1], currentGold);

        };

        const formatThousand = (value: string) => {
            return toLocaleString(Number(value));
        };

        const iconUrl = computed(() => {            
            return props.source === 'taskCenter' ? coins[appName] || coinIcon : lockIcon;
        });

        const positionedPoint = computed(() => {
            if (props.positionList.length === 0 ) {
                return [];
            }

            // @ts-ignore todo: contentElement 类型添加
            const contentWidth = contentElement?.value?.offsetWidth ?? '0';
            const valueAndWidthRatio = 1;
            const maxValue = props.positionList[props.positionList.length - 1] as number;
            const maxWidth = (maxValue / valueAndWidthRatio < contentWidth ? contentWidth : maxValue / valueAndWidthRatio) - 25;
            
            const points = props.positionList.map((point, index) => {
                return {
                    value: props.pointList[index] as number,
                    gap: range(0, maxValue, 0, maxWidth, point as number),
                };
            });
            scrollToMiddle(points, contentWidth, maxWidth);

            return {
                points,
                currentWidth: range(0, maxValue, 0, maxWidth, getLerpInFakeNumber(props.currentGold)),
                maxWidth,
            };
        });

        return {
            ...toRefs(state),
            barElement,
            contentElement,
            positionedPoint,
            iconUrl,
            formatThousand,
        };
    },
});
